import React, { useState } from 'react';

import BasicDropdown from '../../common/BasicDropdown/BasicDropdown';
import ConfirmationDialog from '../../common/ConfirmationDialog/ConfirmationDialog';
import Label from '../../common/Labels/Label';
import TimeRangePicker from '../../TimeRangePicker/TimeRangePicker';

export const TASK_RUN_STATUS = {
  Running: 'Running',
  Success: 'Success',
  Failure: 'Failure',
  All: 'all',
}

const TASK_RUN_STATUS_OPTIONS = [
  {
    id: TASK_RUN_STATUS.All,
    label: 'All Statuses',
  },
  {
    id: TASK_RUN_STATUS.Running,
    label: 'Running',
  },
  {
    id: TASK_RUN_STATUS.Success,
    label: 'Success',
  },
  {
    id: TASK_RUN_STATUS.Failure,
    label: 'Failure',
  },
]

export const RELATIVE_TIME_RANGES = [
  { type: 'All time', duration: null },
  { type: 'Last 30 seconds', duration: { seconds: -30 } },
  { type: 'Last 60 seconds', duration: { seconds: -60 } },
  { type: 'Last 5 minutes', duration: { minutes: -5 } },
  { type: 'Last 15 minutes', duration: { minutes: -15 } },
  { type: 'Last 30 minutes', duration: { minutes: -30 } },
  { type: 'Last hour', duration: { hours: -1 } },
  { type: 'Last 3 hours', duration: { hours: -3 } },
  { type: 'Last 6 hours', duration: { hours: -6 } },
  { type: 'Last 12 hours', duration: { hours: -12 } },
  { type: 'Last day', duration: { days: -1 } },
  { type: 'Last 2 days', duration: { days: -2 } },
  { type: 'Last 7 days', duration: { days: -7 } },
];

const POPOVER_TO_SIDE = {
  mt: 1,
  left: 108,
  bottom: -264,
}

export const TaskRunFilterModal = ({
  filter = {
    timeRange: RELATIVE_TIME_RANGES[0],
    taskRunStatus: TASK_RUN_STATUS.All,
  },
  showDialog = false,
  onDialogToggle = () => {},
  onFilterConfirm = () => {},
  onClear = () => {},
}) => {
  const [selectedTaskRunStatus, setSelectedTaskRunStatus] = useState(filter.taskRunStatus);
  const [selectedTimeRange, setSelectedTimeRange] = useState(filter.timeRange);

  const handleConfirmation = () => {
    onFilterConfirm({
      taskRunStatus: selectedTaskRunStatus,
      timeRange: selectedTimeRange,
    });
  }

  return (
    <ConfirmationDialog
      title="Filter"
      confirmButtonText="Apply"
      cancelButtonText="Clear All"
      modalAnimationKey="task-runs-filter"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={handleConfirmation}
      onCancel={onClear}
    >
      <div className="flex flex-col w-small-modal mx-2 my-3">
        <div className="flex m-1 items-center">
          <div className="flex flex-col">
            <Label className="my-1" bold>Task Run Status</Label>
            <BasicDropdown
              values={TASK_RUN_STATUS_OPTIONS}
              selectedValue={selectedTaskRunStatus}
              onValueSelected={setSelectedTaskRunStatus}
              hideLabelInSmallViewports={false}
              dropdownLabel=""
            />
          </div>
          <Label className="mx-2 mt-8">within</Label>
          <div className="flex flex-col">
            <Label className="my-1" bold>Timeframe</Label>
            <TimeRangePicker
              onChange={setSelectedTimeRange}
              selectedRange={selectedTimeRange}
              relativeRanges={RELATIVE_TIME_RANGES}
              popoverStyle={POPOVER_TO_SIDE}
              popoverDirection="left"
              hideFullLabelOnRange
            />
          </div>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default TaskRunFilterModal;
